<table
  class="table"
  [class.table--alternate-rows]="alternativeRows()"
  [class.table--no-borders]="noBorders()">
  @if (title() !== null) {
    <thead>
      <tr>
        <th colspan="2" class="table__header">{{ title() }}</th>
      </tr>
    </thead>
  }
  <tbody>
    @for (element of elements(); track element.id) {
      <tr class="table__row">
        <td class="table__cell table__cell--name">
          <div class="table__cell-content">
            <p>{{ element.name }}</p>
            @if (element.hasInfo) {
              <button
                type="button"
                class="table__info-button"
                (click)="onInfoClick(element.id)"
                aria-label="Information">
                <img
                  src="./assets/lib/icons/info_icon.svg"
                  alt="Information"
                  class="table__info-icon" />
              </button>
            }
          </div>
        </td>
        <td class="table__cell table__cell--description">{{ element.description }}</td>
      </tr>
    }
    @if (finalElement()) {
      <tr class="table__row table__row--final">
        <td class="table__cell table__cell--name table__cell--final">
          <div class="table__cell-content">
            <p>{{ finalElement()!.name }}</p>
            @if (finalElement()!.hasInfo) {
              <button
                type="button"
                class="table__info-button"
                (click)="onInfoClick(finalElement()!.id)"
                aria-label="Information">
                <img
                  src="./assets/lib/icons/info_icon.svg"
                  alt="Information"
                  class="table__info-icon" />
              </button>
            }
          </div>
        </td>
        <td class="table__cell table__cell--description table__cell--final">{{ finalElement()!.description }}</td>
      </tr>
    }
  </tbody>
</table>
